<template lang="pug">
  button.button(type='button' :class="classList") {{ text }}
</template>

<script>
  export default {
    name: 'ButtonItem',
    props: {
      classList: {
        type: String,
        required: false,
        default: ''
      },
      text: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped lang="stylus">
.button
  display inline-block
  padding 0.8rem 3.8rem
  border: 2px solid #000000
  min-width 20rem

  font-size: 1.6rem
  color: #000000
  font-weight 500
  letter-spacing: -0.2px
  text-align: center
  line-height: 1.375

  background: #FFFFFF
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50)
  user-select none
  transition background-color 0.15s linear,
    border-color 0.15s linear,
    box-shadow 0.15s linear
  @media $tablet
    min-width auto
    padding 2.1rem 4.7rem
    font-size 2rem
  &:hover
    color: #fff
    background: #FF036D
    box-shadow: 0 3px 5px 0 rgba(255,3,109,0.50)
  &:focus
    outline 0
    box-shadow: 0 2px 4px 0 rgba(255,3,109,0.50)
  &:active
    box-shadow none
  &[disabled]
    opacity: 0.5
  // appearence
  &_dark
    color #fff
    background-color #000
    &:hover
      background-color $pink
      border-color $pink
  // size
  &_md
    padding 0.6rem 3.8rem
    @media $tablet
      padding 1.2rem 3.8rem
  &_sm
    padding 0.8rem 3.8rem

</style>
